import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.is-array";
import "core-js/modules/es.array.map";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.includes";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import { loading, enumData, userPrefPageSize } from '@/decorators';
import { writePageToken, setPageToken } from '@/components/pagination';

var AbnormalList = function (_super) {
  __extends(AbnormalList, _super);

  function AbnormalList() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.total = 0;
    _this.selectedIds = [];
    _this.selectedRowKeys = [];
    _this.loadingStatus = false;
    _this.loadingTable = false;
    _this.rowSelection = {};
    _this.changeTypeList = [];
    _this.changeNodes = [];
    _this.confirmStatusList = [];
    _this.searchData = _this.getInitSearchData();
    _this.searchTypes = {
      codeType: 'product_sku',
      codeTypeValue: '',
      timeType: 'edit',
      timeTypeValue: _this.$util.getDefaultTimeCondition()
    };
    _this.columns = [{
      title: _this.t('商品编码'),
      dataIndex: 'product_sku',
      scopedSlots: {
        customRender: 'product_sku'
      }
    }, {
      title: _this.t('谷仓商品条码'),
      dataIndex: 'product_barcode',
      filterEmpty: true,
      isCopy: true
    }, {
      title: _this.t('参考编码'),
      dataIndex: 'reference_number',
      filterEmpty: true,
      isCopy: true
    }, {
      title: _this.t('关联单号'),
      dataIndex: 'relevancy_order',
      filterEmpty: true,
      isCopy: true
    }, {
      title: _this.t('变更节点'),
      dataIndex: 'edit_point_text',
      filterEmpty: true
    }, {
      title: _this.t('变更类型'),
      dataIndex: 'message_notification_code_text',
      filterEmpty: true
    }, {
      title: _this.t('变更前'),
      dataIndex: 'original_value',
      scopedSlots: {
        customRender: 'original_value'
      },
      filterEmpty: true
    }, {
      title: _this.t('变更后'),
      dataIndex: 'current_value',
      filterEmpty: true
    }, {
      title: _this.t('变更时间'),
      dataIndex: 'update_time',
      filterEmpty: true
    }];
    _this.listData = [];
    return _this;
  }

  AbnormalList.prototype.getInitSearchData = function () {
    return {
      message_notification_code: undefined,
      edit_point: undefined,
      read_status: undefined,
      product_sku: '',
      reference_number: '',
      begin_edit_time: '',
      end_edit_time: '',
      page_index: 1,
      page_size: 20
    };
  };

  AbnormalList.prototype.handlePageChange = function (val) {
    setPageToken(this.searchData, val);
    this.initPage();
    this.searchData.page_index = val;
    this.queryAbnormalProductList();
  };

  AbnormalList.prototype.created = function () {
    var _this = this;

    this.rowSelection = {
      selectedRowKeys: [],
      onChange: function onChange(selectedRowKeys) {
        _this.rowSelection.selectedRowKeys = _this.selectedIds = selectedRowKeys;
      }
    };
    var status = this.$route.query.status;

    if (status) {
      this.searchData.read_status = Number(status);
      this.searchTypes.timeTypeValue = this.$util.getDefaultTimeCondition(this.$util.monthToDay());
    }

    var code = this.$route.query.code;

    if (code) {
      this.searchTypes.codeTypeValue = code;
      this.searchTypes.timeTypeValue = [];
    }

    this.queryAbnormalProductList();
  };

  AbnormalList.prototype.formatParams = function () {
    var postData = {};
    this.searchData.product_sku = '';
    this.searchData.reference_number = '';
    this.searchData.relevancy_order = '';
    this.searchData[this.searchTypes.codeType] = this.searchTypes.codeTypeValue;
    this.searchData["begin_" + this.searchTypes.timeType + "_time"] = this.searchTypes.timeTypeValue.length ? this.$util.formatDateTime(this.searchTypes.timeTypeValue[0]) : '';
    this.searchData["end_" + this.searchTypes.timeType + "_time"] = this.searchTypes.timeTypeValue.length ? this.$util.formatDateTime(this.searchTypes.timeTypeValue[1]) : '';

    for (var _i = 0, _a = Object.keys(this.searchData); _i < _a.length; _i++) {
      var item = _a[_i];
      var itemValue = this.searchData[item];

      if (itemValue || itemValue === 0 || Array.isArray(itemValue) && itemValue.length) {
        postData[item] = itemValue;
      }
    }

    return postData;
  };

  AbnormalList.prototype.queryAbnormalProductList = function () {
    return __awaiter(this, void 0, Promise, function () {
      var postData, resData, _a, list, _b, total, partRestKeys, searchData, _i, _c, item;

      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            this.rowSelection.selectedRowKeys = this.selectedIds = [];
            this.lastParams = JSON.parse(JSON.stringify(this.formatParams()));
            postData = Object.assign({}, this.lastParams, {
              page_index: this.searchData.page_index,
              page_size: this.searchData.page_size
            });
            return [4, this.$api.product.queryAbnormalProductList(postData)];

          case 1:
            resData = _d.sent().data;
            _a = resData.list, list = _a === void 0 ? [] : _a, _b = resData.total, total = _b === void 0 ? 0 : _b;
            this.listData = list;
            this.total = total;
            writePageToken(this.searchData, {
              prev_token: resData.prev_token,
              next_token: resData.next_token,
              zt_list_es_point: resData.zt_product_list_es_point
            });
            partRestKeys = ['product_sku', 'reference_number', 'relevancy_order', 'begin_edit_time', 'end_edit_time'];
            searchData = this.getInitSearchData();

            for (_i = 0, _c = Object.keys(searchData); _i < _c.length; _i++) {
              item = _c[_i];

              if (partRestKeys.includes(item)) {
                this.searchData[item] = searchData[item];
              }
            }

            return [2];
        }
      });
    });
  };

  AbnormalList.prototype.handleExport = function (isAll) {
    return __awaiter(this, void 0, Promise, function () {
      var postData, res;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            if (!isAll && !this.selectedIds.length) {
              return [2, this.$message.warn(this.tc(this.$config.exportSelectedEmptyTip))];
            }

            postData = isAll ? this.lastParams : {
              message_notification_id_list: this.selectedIds
            };
            return [4, this.$api.product.abnormalProductExport(postData)];

          case 1:
            res = _a.sent();

            if (res.code === 0) {
              this.$util.exportExcel(res.data);
            }

            return [2];
        }
      });
    });
  };

  AbnormalList.prototype.getSelectedSkuList = function () {
    var data = this.productList.filter(function (item) {
      return item.checked;
    });

    if (!data.length) {
      this.$message.warning(this.t('请选择修改项!'));
      return;
    }

    return data.map(function (item) {
      return item.product_sku;
    });
  };

  AbnormalList.prototype.initPage = function () {
    this.searchData.page_index = 1;
  };

  AbnormalList.prototype.handleReset = function () {
    this.searchData = this.getInitSearchData();
    this.searchTypes.codeTypeValue = '';
    this.searchTypes.timeTypeValue = this.$util.getDefaultTimeCondition();
    this.queryAbnormalProductList();
  };

  AbnormalList.prototype.handleSearch = function () {
    this.initPage();
    this.queryAbnormalProductList();
  };

  __decorate([enumData('ProductEx/MessageNotificationCodeEnum')], AbnormalList.prototype, "changeTypeList", void 0);

  __decorate([enumData('ProductEx/EditPointEnum')], AbnormalList.prototype, "changeNodes", void 0);

  __decorate([enumData('ProductEx/ReadStatusEnum')], AbnormalList.prototype, "confirmStatusList", void 0);

  __decorate([userPrefPageSize('productAbnormalList')], AbnormalList.prototype, "getInitSearchData", null);

  __decorate([loading('loadingTable')], AbnormalList.prototype, "queryAbnormalProductList", null);

  AbnormalList = __decorate([Component], AbnormalList);
  return AbnormalList;
}(Vue);

export default AbnormalList;